import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const CodiLazy = createLazyComponent(() => import('./Codi'))

const Codi = (props) => <CodiLazy {...props} />

export default Codi
